import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@fortawesome/fontawesome-free/css/all.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import { previewFileAddress, previewFileAddressList } from "@/utils/utils"
Vue.prototype.$previewFileAddress = previewFileAddress
Vue.prototype.$previewFileAddressList = previewFileAddressList

Vue.use(ElementUI)
Vue.config.productionTip = false

// 应用初始化时获取系统配置
store.dispatch('system/getSystemInit')
  .then(response => {
    console.log('系统配置获取成功:', response.data)
  })
  .catch(error => {
    console.error('系统配置获取失败:', error)
  })

// 注册全局路由跳转函数
Vue.prototype.$routePath = function(path) {
  this.$router.push(path).catch(err => {
    console.error('路由跳转错误:', err)
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 确保初始路径为 /
router.beforeEach((to, from, next) => {
  // 如果是首次访问，重定向到根路径
  if (from.name === null && to.path !== '/') {
    next('/')
  } else {
    next()
  }
})
